import type { TDatadogErrorLog } from 'utils/datadog/types'

export const UPDATE_POST_LOG: TDatadogErrorLog = {
  from: 'src/modules/posts/video-info/video-info.model.ts',
  name: 'Update post',
  message: 'Update post mutation failed',
}

export const RESPONSE_POST_LOG: TDatadogErrorLog = {
  from: 'src/modules/posts/video-info/video-info.model.ts',
  name: 'Get post update status',
  message: 'Get post update status query failed',
}

export const POLL_INTERVAL_MS = 600000
